import * as _ from 'lodash';
import {PostalAddressForm} from '../../../../services/locations/locationAddress/PostalAddressForm'
import reactSelectStyles from '../../../../services/config/reactSelect/reactSelectStyles'
import reactSelectTheme from '../../../../services/config/reactSelect/reactSelectTheme'
import {IndicatorsContainer,DropdownIndicator,IndicatorSeparator} from '../../../../services/config/reactSelect/components';

(function () {
  'use strict';



  var mod = angular.module('clientDashboardApp.admin.locations.locationEditor', [
    'clientDashboardApp.admin.accounts'
  ])
  mod.value('PostalAddressForm', PostalAddressForm)
  mod.controller('LocationsEditorCtrl', LocationsEditorCtrl);

  function LocationsEditorCtrl($q, $state, $stateParams, $scope, locationId, $location, locationMgmtService,
                               locationsManagerService, configService, accountId, stringService, confirmService,
                               updateService, accountsService, keywordService, type, mode, $uibModalInstance, $timeout, $uibModal) {

    var vm = this;

    vm.setPostalAddress = (addr, errors) => {
      vm.postalAddress = addr
      vm.setPostalAddressDirty()
      // vm.setPostalAddressValidity(errors)
      /* Passing in a call to setPostalAddressValidity through the PostalAddressForm.setValidity. No need to call it again here
         PostalAddressForm is a React component making calls to an Angular controller. We end up with a with a weird mulitiple call
         condition that screws things up when you copy and paste or use autofill for the address
      */
    }

    vm.setPostalAddressDirty = () => {
      vm.createEditLocForm.$setDirty()
    }

    vm.setPostalAddressValidity = (errors) => {
      vm.createEditLocForm.$setValidity("postalAddressForm", !errors.length, LocationsEditorCtrl)
    }

    vm.postalAddress = {}


    vm.isModalView = !!$uibModalInstance
    vm.mode = mode
    vm.locationType = type === 'location' ? 'Customer' : 'Competitor'
    vm.isHourCloningEnabled = true;
    vm.isHoursFormatted = false;
    vm.noOptions = () => 'Type to search'

    function isCustomer() {
      return vm.locationType === 'Customer';
    }

    vm.isCustomer = isCustomer()
    vm.createEditLocForm = {};

    vm.showAccountSelection = false;

    vm.yelpCategories = [] // All available yelp categories
    vm.bingCategories = [] // All available bing categories
    vm.appleCategories = new Set() // All available apple categories

    var states = {
      LoadingData: 'LoadingData',
      UserEditing: 'UserEditing',
      PendingConfirmation: 'PendingConfirmation',
      Success: 'Success'
    };

    vm.state = states.LoadingData;
    vm.formSubmitted = false;

    vm.maxRepeaterItems = {
      socialMonitoring: 50
    }

    vm.paymentTypes = ["American Express", "Visa", "MasterCard", "Discover", "Cash", "Check"]
      .sort((a, b) => a > b)
      .map(t => ({display: t, selected: false}))


    vm.setValidHours = () => {
      vm.createEditLocForm.$setValidity("regularHours", true,  LocationsEditorCtrl)
    }

    vm.adjustTimeValuesSpecialCases = () => {
      vm.days.forEach((day) => {
        if (vm.location.listingManagementSpecs.hours[day.code].blocks.length > 0){
          let blocks = vm.location.listingManagementSpecs.hours[day.code].blocks
          blocks.forEach((block) => {
            //when closing time is 12AM we want to change that to military 24 since it means closing at midnight.
            if (block.to == "12:00 AM" || block.to == "0000"){
              block.to = "2400"
            }
          });
        }
      })
    }

    vm.validateRegularHourBlocks = () =>{
      if(!vm.createEditLocForm.$setValidity || !vm.location.listingManagementSpecs){return}

      //private time block validator.
      const isValidBlock = (block) => {
        const TWELVE_AM = moment("12:00 AM", "hh:mm a");
        const fromTime = moment(block.from, "hh:mm a");
        const toTime = moment(block.to, "hh:mm a");

        //ignore validation on special cases
        if(toTime.isSame(TWELVE_AM)){
          return true;
        }

        //The commented code below forces users to only include hours within the same day
        //return toTime.isAfter(fromTime);

        //We're now allowing users to extend hours beyond the current day
        return true
      }

      const dayErrors = [];

      vm.days.forEach((day) => {

        //if the day has blocks make sure they are chronologically correct.
        //this takes care of empty/invalid/etc..
        if (vm.location.listingManagementSpecs.hours[day.code].blocks.length > 0){
          //for each block check from and to times
          let blocks = vm.location.listingManagementSpecs.hours[day.code].blocks
          blocks.forEach((block) => {
            //if found error add day name to dayErrors
            if(!isValidBlock(block)){ dayErrors.push(day.code)}
          })
        }

        if (dayErrors.length === 0){
          vm.location.listingManagementSpecs.areRegularHourBlocksValid = true;
          vm.createEditLocForm.$setValidity("regularHours", true, LocationsEditorCtrl )
        } else {
          vm.createEditLocForm.$setValidity("regularHours", false, LocationsEditorCtrl);
          vm.location.listingManagementSpecs.areRegularHourBlocksValid = false;
        }
      });
    }

    vm.days = [
      {code: "Monday", display: "Monday"},
      {code: "Tuesday", display: "Tuesday"},
      {code: "Wednesday", display: "Wednesday"},
      {code: "Thursday", display: "Thursday"},
      {code: "Friday", display: "Friday"},
      {code: "Saturday", display: "Saturday"},
      {code: "Sunday", display: "Sunday"}
    ];

    // sets days of week with open closed properties.
    vm.initDaysOfWeek = () => {
      if(vm.mode === 'create'){
        if (_.has(vm, "createEditLocForm.$setValidity")) {
          vm.createEditLocForm.$setValidity("regularHours", false, LocationsEditorCtrl);
        }
      }

      vm.days.forEach((day) => {
        /* when this is a create location mode add empty blocks to each hours-day
         - on create days are not set to clsoed by default. It forces user to enter dates.
         - on edit if no blocks found mark day as closed.
        */
        if (vm.mode === "create"){
          if (vm.location.listingManagementSpecs.hours[day.code].blocks.length == 0 && !vm.location.listingManagementSpecs.hours[day.code].isNone){
            vm.location.listingManagementSpecs.hours[day.code].blocks.push({from:"",to:""});
          }

          vm.location.listingManagementSpecs.hours[day.code].status = "Open"
        } else {
          //if the blocks are not there in hours means this is closed
          day.isClosed = (vm.location.listingManagementSpecs.hours[day.code].blocks.length === 0 && vm.location.listingManagementSpecs.hours[day.code].status === "Closed");
          day.isNone = (vm.location.listingManagementSpecs.hours[day.code].blocks.length === 0 && (vm.location.listingManagementSpecs.hours[day.code].status === undefined || vm.location.listingManagementSpecs.hours[day.code].status === "Open"));
          if (day.isClosed || day.isNone){
            //set the day so an empty array here alomst makes sense
            vm.location.listingManagementSpecs.hours[day.code].blocks= [];
            //don't allow cloning if Monday has no hours.
            if(day.code == "Monday"){vm.isHourCloningEnabled = false}
          }

          if (!day.isClosed && day.isNone) {
            // Set the location to open so that if nothing changes, the location isn't marked closed for that day.
            vm.location.listingManagementSpecs.hours[day.code].status = "Open";
          }

          //check if 24 hrs and set it for checkbox.
          if (!day.isClosed && !day.isNone) {
            day.is24hrs = vm.location.listingManagementSpecs.hours[day.code].blocks[0].to == "2400" &&
              vm.location.listingManagementSpecs.hours[day.code].blocks[0].from == "0000";
          }
        }
      })
      if ("createdit".indexOf(vm.mode)) vm.validateRegularHourBlocks();
    }

    vm.initDisplayFormats = () => {
      if (vm.mode !== "create") {
        vm.days.forEach((day) => {
          vm.location.listingManagementSpecs.hours[day.code].blocks.forEach((block) => {
            let blockis24hrs = (block.from == "0000" && block.to == "2400");
            if (!blockis24hrs) {
              block.from = moment(block.from, 'HHmm').format('hh:mm A').toString();
              block.to = moment(block.to, 'HHmm').format('hh:mm A').toString();
            }
          })
        });
      }
      vm.isHoursFormatted = true;
    }

    vm.toALtimeformat = () => {
      if (vm.location.listingManagementSpecs) {
        vm.days.forEach((day) => {
          vm.location.listingManagementSpecs.hours[day.code].blocks.forEach((block) => {

            block.from = moment(block.from, 'hh:mm A').format('HHmm');
            block.to = moment(block.to, 'hh:mm A').format('HHmm');
            //if 24 hrs special case.
            //set format manually.
            if (block.from === "0000" && block.to == "0000") {
              block.from = "0000";
              block.to = "2400";
            }
          })
        });

        vm.adjustTimeValuesSpecialCases()
      }
    }

    //used by the text links that are not bound to the model
    vm.toggleDayClosed = (day) => {
      const dayOfTheWeek = vm.getDayOfWeek(day.code);
      dayOfTheWeek.isClosed = !dayOfTheWeek.isClosed;
      vm.createEditLocForm.$setDirty();
      vm.regularDayClosedAction(day);
    }

    //used by the text links that are not bound to the model
    vm.toggleDay24hrs = (day) => {
      vm.createEditLocForm.$setDirty();
      const dayOfTheWeek = vm.getDayOfWeek(day.code);
      dayOfTheWeek.is24hrs = !dayOfTheWeek.is24hrs;
      vm.regularDay24hrsAction(day);
    }

    vm.toggleDayNoneAction = (day) => {
      vm.createEditLocForm.$setDirty();
      day.isNone = !day.isNone;
      vm.regularDayNoneAction(day)
    }

    vm.getDayOfWeek = (dayCode = "none") => vm.days.filter((day) => day.code == dayCode)[0];

    //only used when you need to know if a day is closed.
    vm.isDayClosed = (dayCode) => {
      const dayOfTheWeek = vm.getDayOfWeek(dayCode);
      return _.get(dayOfTheWeek, 'isClosed');
    };

    vm.isDayNone = (dayCode) => {
      const dayOfTheWeek = vm.getDayOfWeek(dayCode);
      return _.get(dayOfTheWeek, 'isNone');
    }

    //only used when you need to know if a day is 24hrs.
    vm.isDay24hrs = (day) => {
      const dayOfTheWeek = vm.getDayOfWeek(day.code) ;
      return _.get(dayOfTheWeek, 'is24hrs');
    };

    vm.isAddRegularBlocksDisabled = (dayCode) => {
      const dayOfTheWeek = vm.getDayOfWeek(dayCode);
      return dayOfTheWeek.isClosed || dayOfTheWeek.is24hrs;
    };

    vm.addRegularDayEmptyBlock = (day) => {
      //Note this should not add a new block if its closed or 24 hrs.
      const regularDayBlocks = vm.location.listingManagementSpecs.hours[day.code].blocks;
      regularDayBlocks.push({from: "", to: ""})
    };

    vm.removeRegularDayTimeBlock = (day, index) => {
      const regularDayBlocks = vm.location.listingManagementSpecs.hours[day.code].blocks;
      regularDayBlocks.splice(index, 1);
      //set the form as dirty so you can save even if no inputs changed.
      vm.createEditLocForm.$setDirty();
    }

    vm.regularDayNoneAction = (day) => {
      if(day.isNone === false) {
        if(day.code == "Monday"){vm.isHourCloningEnabled = true}
        vm.location.listingManagementSpecs.hours[day.code].blocks = [{from:"", to:""}];
      }

      if(day.isNone === true) {
        day.isClosed = false;
        delete day.is24hrs
        delete vm.location.listingManagementSpecs.hours[day.code].isBlock24hrs;
        if(day.code == "Monday"){vm.isHourCloningEnabled = false}
        vm.location.listingManagementSpecs.hours[day.code].status = "Open";
        vm.location.listingManagementSpecs.hours[day.code].blocks = [];
      }
    }

    /**
     * Closed action when hours for a regular  day's checkbox is clicked.
     * @param {bool} day - a day from the local vm.days array
     * Note: when a day is closed it needs to be a zero length array for AL.
     *     a backup of previous hours is preserved for toggle funciton
     */
    vm.regularDayClosedAction = (day) => {
      vm.lastSavedRegularDayHours = vm.lastSavedRegularDayHours || [];
      //when closed gets unchecked.
      if (day.isClosed === false){
        //recover last hours if any
        if(_.has(vm.lastSavedRegularDayHours[day.code], "blocks")) {
          vm.location.listingManagementSpecs.hours[day.code].blocks = _.cloneDeep(vm.lastSavedRegularDayHours[day.code].blocks);
        }
        if(day.code == "Monday"){vm.isHourCloningEnabled = true}
        //remove 24hrs from block
        delete  vm.location.listingManagementSpecs.hours[day.code].isBlock24hrs;
        //toggle closed status
        vm.location.listingManagementSpecs.hours[day.code].status = "Open";
        //if you uncheck and the hours were new, then add empty block this is to allow entry of hours.
        vm.location.listingManagementSpecs.hours[day.code].blocks = [{from:"", to:""}];
      }
      //when closed gets checked.
      if (day.isClosed === true){
        delete day.is24hrs
        delete day.isNone
        //set can clone to none if thyis is monday.
        if(day.code == "Monday"){vm.isHourCloningEnabled = false}
        //backup last block to revert when toggled
        vm.lastSavedRegularDayHours = _.cloneDeep(vm.location.listingManagementSpecs.hours);
        //remove all blocks. AL indicator that is closed
        vm.location.listingManagementSpecs.hours[day.code].blocks = [];
        vm.location.listingManagementSpecs.hours[day.code].status = "Closed";
        vm.location.listingManagementSpecs.hours[day.code];
        delete vm.location.listingManagementSpecs.hours[day.code].is24hrs;
      }
    }

    //24hrs action
    vm.regularDay24hrsAction = (day, block) => {
      vm.lastSavedRegularDayHours = vm.lastSavedRegularDayHours || [];
      vm.isHourCloningEnabled = true;

      if (day.is24hrs === false){
        if(_.has(vm.lastSavedRegularDayHours[day.code], "blocks")) {
          vm.location.listingManagementSpecs.hours[day.code].blocks = _.cloneDeep(vm.lastSavedRegularDayHours[day.code].blocks);

          //if the restored toggled hours are military 24 reset to nothing.
          if (vm.location.listingManagementSpecs.hours[day.code].blocks[0]=="2400"){
            vm.location.listingManagementSpecs.hours[day.code].blocks = [{from:"",to:""}]
          }

          //if the restored blocks are empty i.e. last state was closed then use an empty block.
          if(vm.location.listingManagementSpecs.hours[day.code].blocks.length == 0){
            vm.location.listingManagementSpecs.hours[day.code].blocks = [{from:"",to:""}]
          }

          vm.location.listingManagementSpecs.hours[day.code].isBlock24hrs = false;
          vm.location.listingManagementSpecs.hours[day.code].isClosed = false;
        }
      }

      if (day.is24hrs === true){
        //backup last block to revert when toggled
        vm.lastSavedRegularDayHours = _.cloneDeep(vm.location.listingManagementSpecs.hours);
        day.isClosed = false;
        day.isNone = false;
        delete  day.status;
        vm.location.listingManagementSpecs.hours[day.code].status = "Open"
        vm.location.listingManagementSpecs.hours[day.code].isBlock24hrs = true
        //if closed is unchecked restore hours.
        vm.location.listingManagementSpecs.hours[day.code].blocks = [{
          from: "0000", to: "2400"
        }]
      }
    }

    vm.setDirty = () => {
      vm.createEditLocForm.$setDirty();
    }

    //clones hours from Monday to all other regular days.
    vm.setAllDaysSameAsMonday = () => {
      let mondayHours = _.cloneDeep(vm.location.listingManagementSpecs.hours.Monday);
      vm.createEditLocForm.$setDirty();
      vm.days.forEach((day) => {
        if (day.code !== "Monday") { //clone to all days except itself
          vm.location.listingManagementSpecs.hours[day.code].blocks = []
          delete vm.location.listingManagementSpecs.hours[day.code].status
          delete vm.location.listingManagementSpecs.hours[day.code].isClosed
          delete vm.location.listingManagementSpecs.hours[day.code].isBlock24hrs
          delete day.is24hrs
          delete day.isClosed
          delete day.isNone

          mondayHours.blocks.forEach((block) => {
            vm.location.listingManagementSpecs.hours[day.code].blocks.push(_.cloneDeep(block))

            if (_.has(mondayHours, "status")){
              vm.location.listingManagementSpecs.hours[day.code].status = mondayHours.status;
            }

            if (_.has(mondayHours, "isBlock24hrs")){
              vm.location.listingManagementSpecs.hours[day.code].isBlock24hrs = mondayHours.isBlock24hrs;
              if (mondayHours.isBlock24hrs){day.is24hrs = true;}
            }

            if(mondayHours.status === "Closed"){
              day.isClosed = true;
              vm.location.listingManagementSpecs.hours[day.code].status = "Closed"
            }
          })
        }
      });
    }


    vm.reactSelectBootstrap = reactSelectStyles();
    vm.reactSelectTheme = reactSelectTheme;
    vm.loadingCats = false;
    vm.componentOverrides = {IndicatorsContainer, DropdownIndicator, IndicatorSeparator};
    vm.fetchCategories = function(input, ...rest) {
      if (typeof input !== 'undefined' && input.length === 0) {
        return Promise.resolve([])
      }

      return keywordService.listKeywords(input, 0, 1000, vm.isListingManagement).then(results => {

        // sort to prefer results that have the substring as a prefix. Ideally db would order this way to
        const sorted = results.keywords.slice().sort((a, b) => {
          let aPrefixed = !!input && a.text.toLowerCase().slice(0, input.length) === input.toLowerCase();
          let bPrefixed = !!input && b.text.toLowerCase().slice(0, input.length) === input.toLowerCase();
          if (aPrefixed === bPrefixed) {
            return a.text.localeCompare(b.text)
          } else {
            return aPrefixed ? -1 : 1
          }
        })
        return sorted.map(kw => ({value: kw.text, label: kw.text})) //{
        //}
      })
    }

    /** To do simplify the code. fetchCategories and fetchBingCategories share a lot of code */
    vm.fetchBingCategories = function(input, ...rest) {
      if (typeof input !== 'undefined' && input.length === 0) {
        return Promise.resolve([])
      }

      return keywordService.listBingCategories(input, 0, 1000).then(results => {

        // sort to prefer results that have the substring as a prefix. Ideally db would order this way to
        const sorted = results.categories.slice().sort((a, b) => {
          let aPrefixed = !!input && a.text.toLowerCase().slice(0, input.length) === input.toLowerCase();
          let bPrefixed = !!input && b.text.toLowerCase().slice(0, input.length) === input.toLowerCase();
          if (aPrefixed === bPrefixed) {
            return a.text.localeCompare(b.text)
          } else {
            return aPrefixed ? -1 : 1
          }
        })
        return sorted.map(cat => ({value: {BPCategoryId : cat.categoryId, CategoryName : cat.text}, label: cat.text})) //{
        /*options: */ //,
        //complete: results.total <= 1000
        //}
      })
    }

    vm.fetchAppleCategories = function(input, ...rest) {
      if (typeof input !== 'undefined' && input.length === 0) {
        return Promise.resolve([])
      }

      return keywordService.listAppleCategories(input, 0, 1000).then(results => {

        // sort to prefer results that have the substring as a prefix. Ideally db would order this way to
        const sorted = results.categories.slice().sort((a, b) => {
          let aPrefixed = !!input && a.text.toLowerCase().slice(0, input.length) === input.toLowerCase();
          let bPrefixed = !!input && b.text.toLowerCase().slice(0, input.length) === input.toLowerCase();
          if (aPrefixed === bPrefixed) {
            return a.text.localeCompare(b.text)
          } else {
            return aPrefixed ? -1 : 1
          }
        })
        return sorted.map(cat => ({value: {categoryId : cat.categoryId, categoryName : cat.text}, label: cat.text}))
      })
    }

    vm.minPhoneDigits = 0;
    vm.maxPhoneDigits = null;

    vm.pageStrings = stringService.adminStrings(vm.mode);
    vm.locationId = locationId;

    vm.updatePermanentlyClosed = (a, b, c) => {

      const isClosed = vm.location.listingManagementSpecs.permanentlyClosed;

      const message = isClosed ? 'Permanently Closed' : 'Open';

      confirmService.confirm(
        'Warning',
        'Checking this option will update the status of your listings to \'' + message + '\' Are you sure you want to do this?',
        confirmService.WARNING
      ).then(confirmed => {
        if (!confirmed) {
          vm.location.listingManagementSpecs.permanentlyClosed = !isClosed // Revert
        }
      })
    };


    //Setup
    //Get add location data
    var dataLoad = {
      canSeeMultipleAccounts: accountsService.canSeeMultipleAccounts(),
      writeableAccountIds: accountsService.listAccounts().then(resp => resp.accounts.map(x => x.id)),
      editorData: locationMgmtService.locationEditorData(),
      defaultPrimaryCategory: configService.getBrandConfig().then(x => {
        return x.defaultPrimaryCategory
      }),
      yelpCategories: locationMgmtService.yelpCategories(),
      bingCategories: keywordService.listBingCategories("",0,3000,false),
      appleCategories: keywordService.listAppleCategories("",0,3000,false),
      locationYelpCategories: locationMgmtService.locationYelpCategories(locationId),
      lastDataIngestionJob: locationMgmtService.lastDataIngestionJob(locationId), // Last yelp data ingestion job
      account: accountsService.retrieveCurrentAccountInfo(),
      healthcareKeywords: keywordService.listHealthcareKeywords("", 0, 3000, false)
    };

    vm.useAlternateKeyword = function() {
      vm.location.primaryKeyword = vm.alternateKeyword;
      vm.createEditLocForm.primaryKeyword.$setValidity("listingManagement", true)
    }
    vm.pageStrings.pageType = isCustomer() ? 'Location' : 'Competitor';

    if (vm.mode == 'create') {
      vm.location = {
        accountId: isCustomer() ? accountId : '0',
        busName: '',
        resellerLocationId: '',
        primaryKeyword: '',
        website: '',
        alternateWebsites: [],
        email: '',
        alternateEmails: [],
        address: {
          street: '',
          suite: '',
          city: '',
          postalCode: '',
          state: '',
          country: '',
          isServiceAreaLocation: false
        },
        primaryPhone: '',
        alternatePhoneNumbers: [],
        auditOnly: false,
        customListings: [],
        brandMonitoring: {
          listingMonitoring: [{
            name: ''
          }],
          socialMonitoring: []
        },
        rankingKeywords: [],
        imageUrls: [],
        yelpImages: [],
        googleImages: [],
        notes: ''
      };

      if (vm.locationType == 'Competitor') {
        dataLoad.parentLocation = locationsManagerService.loadLocation(locationId);
      }
    }
    else if (vm.mode == 'edit') {
      if (isCustomer()) {
        dataLoad.location = locationsManagerService.syncAndLoadLocation(locationId);
      } else {
        dataLoad.location = locationsManagerService.loadCompetitorLocation(locationId, $stateParams.competitorId);
      }
    }

    vm.additionalCatChanged = function (index) {
      return (cat) => {
        $scope.$evalAsync(() => {
          if (cat) {
            vm.location.listingManagementSpecs.additionalCategories[index] = cat.value;

            if (index <= 3) {
              vm.location.listingManagementSpecs.additionalCategories.push(null);
            }
          } else {
            vm.location.listingManagementSpecs.additionalCategories.splice(index, 1);

            if (vm.location.listingManagementSpecs.additionalCategories.length === 4 &&
              vm.location.listingManagementSpecs.additionalCategories[3] !== null) {
              vm.location.listingManagementSpecs.additionalCategories.push(null)
            }
          }
        });
      }
    };

    vm.keywordChanged = function (newKeyword) {
      if(Array.from(vm.healthcareKeywords).filter(x => x.text == newKeyword.value).length > 0) {
        vm.isHealthcareClient = true
      } else {
        vm.isHealthcareClient = false
      }
      $scope.$evalAsync(() => { // wrap in $evalAsync 'cause the event originates from react
        vm.location.primaryKeyword = newKeyword && newKeyword.value;
        vm.createEditLocForm.primaryKeyword.$setValidity("listingManagement", true)
        vm.createEditLocForm.primaryKeyword.$setDirty();
      })
    }

    function addToBingCategories(newCategory) {
      if (!vm.location.listingManagementSpecs.bingCategories ) {
        vm.location.listingManagementSpecs.bingCategories = new Set()
      }
      vm.location.listingManagementSpecs.bingCategories.add(newCategory && newCategory.value);
    }

    vm.bingCategoryChanged = function (newCategory) {
      $scope.$evalAsync(() => { // wrap in $evalAsync 'cause the event originates from react
        vm.location.listingManagementSpecs.primaryBingCategory = newCategory && newCategory.value;
        addToBingCategories(newCategory);
        vm.createEditLocForm.$setValidity("listingManagement", true);
        vm.createEditLocForm.$setDirty();
      })
    }

    vm.googleCategoriesChanged = function (newCategories) {
      $scope.$evalAsync(() => { // wrap in $evalAsync 'cause the event originates from react
        if(newCategories.length<10) {
          vm.location.listingManagementSpecs.googleCategories = newCategories && newCategories.map(x => x.value).flat();
          vm.createEditLocForm.$setDirty();
        }
      })
    }

    vm.calculatedCategories = function () {
        if(! vm.location.listingManagementSpecs.googleCategories)
          vm.location.listingManagementSpecs.googleCategories = []

        return vm.location.listingManagementSpecs.googleCategories.map(cat => ({
          value:cat,
          label:cat
        }))
      }

    vm.bingCategoriesChanged = function (newCategories, primaryCat) {
      vm.location.listingManagementSpecs.bingCategories = new Set(newCategories);
      if(primaryCat != null ) {
        vm.location.listingManagementSpecs.bingCategories.add(primaryCat);
      }
    }

    function addToAppleCategories(newCategory) {
      if (!vm.location.listingManagementSpecs.appleCategories) {
        vm.location.listingManagementSpecs.appleCategories = new Set()
      }
      if(Array.isArray(vm.location.listingManagementSpecs.appleCategories)) {
        vm.location.listingManagementSpecs.appleCategories.push(newCategory && newCategory.value);
      } else {
        vm.location.listingManagementSpecs.appleCategories.add(newCategory && newCategory.value)
      }
    }

    vm.appleCategoryChanged = function (newCategory) {
      $scope.$evalAsync(() => { // wrap in $evalAsync 'cause the event originates from react
        vm.location.listingManagementSpecs.primaryAppleCategory = newCategory && newCategory.value;
        addToAppleCategories(newCategory);
        vm.createEditLocForm.$setValidity("listingManagement", true);
        vm.createEditLocForm.$setDirty();
      })
    }

    vm.appleCategoriesChanged = function (newCategories, primaryCat) {
      vm.location.listingManagementSpecs.appleCategories = newCategories;
      if(primaryCat != null ) {
        vm.location.listingManagementSpecs.appleCategories.push(primaryCat);
      }
    }

    vm.addSpecialHourPeriod = () => {

      let emptyPeriod = {
        "specialStartDate": {
          "year": null,
          "month": null,
          "day": null,
          "rawDate": ""
        },
        "openTime": null,
        "closeTime": null,
        "is24hrs": false,
        "isClosed": false
      }; //emptyPeriod

      vm.location.listingManagementSpecs.specialHoursPeriods.push(emptyPeriod);
    };

    /*used by children directives to communicate custom validation*/
    $scope.$on("validateDateRange", function(event, data){
      vm.specialHoursHasError = false
      try {$scope.$apply()}catch (e){}
    });

    $scope.$on("toggleCloning", function(event, data) {
      vm.isHourCloningEnabled = !!data.isEnabled;
    });


    function setDefaultListingManagementSpecs() {

      vm.location.listingManagementSpecs = vm.location.listingManagementSpecs || {}
      let specs = vm.location.listingManagementSpecs;
      specs.hours = specs.hours || {};

      specs.specialHoursPeriods = vm.location.listingManagementSpecs.specialHoursPeriods || [];

      specs.additionalCategories = _.isEmpty(specs.additionalCategories)
        ? [null]
        : specs.additionalCategories.length < 5
          ? _.concat(specs.additionalCategories, [null])
          : specs.additionalCategories;

      // set/initialize regular hours for each day
      // If we haven't yet initialized the days it means it's the default and we should populate with None if it's not an LLM account
      if (_.isEmpty(_.find(vm.days, {isClosed: false})) && _.isEmpty(_.find(vm.days, {isClosed: true})) &&
        _.isEmpty(_.find(vm.days, {isNone: true})) && _.isEmpty(_.find(vm.days, {isNone: true})) &&
        _.isEmpty(specs.hours) &&
        !vm.isListingManagement) {
        vm.days.forEach((day, i) => {
          specs.hours[day.code] = {status: "Open", blocks: [], isNone: true}
          //Since vm.days is what displays on the UI, we have to set this too
          vm.days[i] = {...vm.days[i], status: "Open", blocks: [], isNone: true}
        });
      }
      else {
        for (let {code} of vm.days) {
          specs.hours[code] = specs.hours[code] || {blocks: []}
        }
      }
      //set closed and 24 hours presets
      vm.initDaysOfWeek();
      // preformat hours for pretty format.
      if (!vm.isHoursFormatted) {vm.initDisplayFormats()};

      specs.providerImages = specs.providerImages || {};

      // Initialize payment types
      if (specs.paymentTypes) {
        specs.paymentTypes.split(",").map(type => {
          const found = _.find(vm.paymentTypes, {display: type})
          if (found) {
            found.selected = true;
          }
        })
      }

      // check if selected keyword is valid for listing management
      vm.location.primaryKeyword && keywordService.isValidForListingManagement(vm.location.primaryKeyword).then(result => {
        if (!result.isValid) {
          vm.createEditLocForm.primaryKeyword.$setValidity("listingManagement", false)
          vm.alternateKeyword = result.alternate
        } else {
          vm.location.primaryKeyword = result.canonical.text
        }
      })

    } //setDefaults for listing managementspecs

    if (vm.locationType === 'Competitor') {
      vm.isListingManagement = false
    } else {
      const getHasListingManagementFromAccount = (accountId) => accountsService
        .getAccount(accountId)
        .then(account => {
          vm.isListingManagement = (vm.locationType !== 'Competitor' && account.data.hasListingManagement)
        })
        .then(() => vm.fetchCategories());

      if (vm.mode === 'create') {
        getHasListingManagementFromAccount(vm.location.accountId)
      } else if (vm.mode === 'edit') {
        dataLoad.isListingManagement = dataLoad.location
          .then(location => location.data.accountId)
          .then(getHasListingManagementFromAccount)
      }
    }

    // Need to hide/show listing management fields depending on what account the location is being created for
    $scope.$watch("vm.location.accountId", newAccountId => {
      if (newAccountId) {
        accountsService.getAccount(newAccountId)
          .then(account => {
            vm.isYelpListingManagement = vm.locationType !== 'Competitor' && account.data.hasListingManagement && account.data.hasYelpListingManagement;
            vm.isBingListingManagement = vm.locationType !== 'Competitor' && account.data.hasListingManagement && account.data.hasBingListingManagement;
            vm.isAppleListingManagement = vm.locationType !== 'Competitor' && account.data.hasListingManagement && account.data.hasAppleListingManagement;
            vm.isGoogleListingManagement = vm.locationType !== 'Competitor' && account.data.hasListingManagement &&  account.data.hasGoogleListingManagement;
            vm.isFacebookListingManagement = vm.locationType !== 'Competitor' && account.data.hasListingManagement &&  account.data.hasFacebookListingManagement;
            vm.isListingManagement = (vm.locationType !== 'Competitor' && account.data.hasListingManagement)
            // Clear listing management properties if the account changes
            setPhotoRows()
            setDefaultListingManagementSpecs()
          })
          .then(x => {
            $timeout(() => $("#yelpCategory").select2({maximumSelectionSize: 3}))
            vm.fetchCategories()
          });


      }
    })

    dataLoad.prefetchCategories = vm.fetchCategories(); // prime the cache

    $q.all(dataLoad).then(function (dataLoad) {
      vm.account = dataLoad.account
      vm.cats = []
      var data = dataLoad.editorData;
      var canSeeMultipleAccounts = dataLoad.canSeeMultipleAccounts;
      var writeableAccountIds = dataLoad.writeableAccountIds;
      vm.showAccountSelection = isCustomer() && canSeeMultipleAccounts && (
        vm.mode == 'create' || _.includes(writeableAccountIds, dataLoad.location.data.accountId)) && !vm.isModalView;
      vm.validCountries = data.countries;
      vm.validCountriesWithFullName = data.countriesWithFullName;
      vm.isListingManagement = dataLoad.account.services.listingManagement && isCustomer()

      vm.yelpCategories = dataLoad.yelpCategories;
      vm.bingCategories = dataLoad.bingCategories.categories.map(cat => ({label: cat.text, value: {BPCategoryId : cat.categoryId, CategoryName : cat.text}}));
      vm.bingCategoriesRaw = dataLoad.bingCategories.categories.map(cat => ({BPCategoryId : cat.categoryId, CategoryName : cat.text}));
      vm.appleCoordinates = dataLoad.appleCoordinates
      vm.appleCategories = dataLoad.appleCategories.categories.map(cat => ({label: cat.text, value: {categoryId : cat.categoryId, categoryName : cat.text}}));
      vm.appleCategoriesRaw = dataLoad.appleCategories.categories.map(cat => ({categoryId : cat.categoryId, categoryName : cat.text}));
      vm.healthcareKeywords = dataLoad.healthcareKeywords.map(kwd => kwd)
      vm.isHealthcareClient = dataLoad.location !== undefined && Array.from(vm.healthcareKeywords).filter(x => x.text == dataLoad.location.data.primaryKeyword).length > 0

      $timeout(() => {
        // Need to run select2 initialization after template loads
        $("#yelpCategory").select2({maximumSelectionSize: 3})
      }, 1)

      vm.state = states.UserEditing;

      if (dataLoad.location) {
        vm.location = dataLoad.location.data;



        initGoogleListingManagementPhotos();
        if (vm.location.listingManagementSpecs) {
          /* Convert bingCategories to a set so we don't allow any duplicates. It comes in as an array by default */
          vm.location.listingManagementSpecs.bingCategories = new Set(vm.location.listingManagementSpecs.bingCategories)
          vm.location.listingManagementSpecs.yelpCategories = dataLoad.locationYelpCategories.categories;
          vm.yelpCategoriesExist = dataLoad.locationYelpCategories.yelpCategoriesExist;
          vm.lastDataIngestionJob = dataLoad.lastDataIngestionJob
          vm.shouldDisableYelpSelection = vm.yelpCategoriesExist

          if (!!vm.location.listingManagementSpecs.temporarilyClosedUntil) {
            // Need to map the temporarily closed until format to a date for the date picker
            vm.location.listingManagementSpecs.temporarilyClosedUntil = moment(vm.location.listingManagementSpecs.temporarilyClosedUntil).format("l")
            vm.showTemporarilyClosed = true
          }

          vm.lastDataIngestionJobErrorMessage = vm.lastDataIngestionJob && vm.lastDataIngestionJob.business_results && vm.lastDataIngestionJob.business_results[0] && vm.lastDataIngestionJob.business_results[0].error && vm.lastDataIngestionJob.business_results[0].error.message

          vm.lastDataIngestionJobStringified = JSON.stringify(dataLoad.lastDataIngestionJob)
          vm.lastDataIngestionJobHasErrors = JSON.stringify(dataLoad.lastDataIngestionJob).toLowerCase().includes("error") ||
            JSON.stringify(dataLoad.lastDataIngestionJob).toLowerCase().includes("rejected")

          console.info("Last Yelp Data Ingestion Job Status:", dataLoad.lastDataIngestionJob)
        }
        var listingMonitoring = vm.location.brandMonitoring.listingMonitoring;
        if (listingMonitoring.length === 0) {
          listingMonitoring.push({
            name: ''
          });
        }
      } else {
        vm.location.primaryKeyword = dataLoad.defaultPrimaryCategory;
      }

      vm.postalAddress = {
        addressCountry: vm.location.address.country,
        addressLocality: vm.location.address.city,
        addressRegion: vm.location.address.state,
        postalCode: vm.location.address.postalCode,
        streetAddress: vm.location.address.street,
        suite: vm.location.address.suite,
        isServiceAreaLocation: vm.location.address.isServiceAreaLocation
      }

      setDefaultListingManagementSpecs();

      vm.setTrackingNumber = (provider, number) => vm.location.listingManagementSpecs.providerTrackingNumbers[provider] = number
      vm.setTrackingWebsiteUrl = (provider, websiteUrl) => vm.location.listingManagementSpecs.providerTrackingWebsiteUrls[provider] = websiteUrl

      if (vm.location.listingManagementSpecs.providerTrackingNumbers) {

        const trackingNumberProviders = ["BING", "FACEBOOK", "GOOGLEMAP", "YELP"];

        // Create empty fields for tracking numbers
        for (let i = 0; i < trackingNumberProviders.length; i++) {
          let provider = trackingNumberProviders[i];
          if (!vm.location.listingManagementSpecs.providerTrackingNumbers[provider]) {
            if (provider !== "YELP") {
              // Yelp doesn't allow tracking numbers
              vm.location.listingManagementSpecs.providerTrackingNumbers[provider] = ""
            } else {
              delete vm.location.listingManagementSpecs.providerTrackingNumbers[provider]
            }
          }
        }
      }
      //Init providerTrackingNumbers
      else {
        vm.location.listingManagementSpecs.providerTrackingNumbers = {
          "BING": "",
          "FACEBOOK": "",
          "GOOGLEMAP": ""
        }
      }

      if (vm.location.listingManagementSpecs.providerTrackingWebsiteUrls) {
        const trackingWebsiteUrlsProviders = ["BING", "FACEBOOK", "GOOGLEMAP", "YELP"];

        // Create empty fields for tracking website urls
        for (let i = 0; i < trackingWebsiteUrlsProviders.length; i++) {
          let provider = trackingWebsiteUrlsProviders[i];
          if (!vm.location.listingManagementSpecs.providerTrackingWebsiteUrls[provider]) {
            if (provider !== "YELP") {
              vm.location.listingManagementSpecs.providerTrackingWebsiteUrls[provider] = ""
            } else {
              delete vm.location.listingManagementSpecs.providerTrackingWebsiteUrls[provider]
            }
          }
        }
      }
      //Init providerTrackingWebsiteUrls
      else {
        vm.location.listingManagementSpecs.providerTrackingWebsiteUrls = {
          "BING": "",
          "FACEBOOK": "",
          "GOOGLEMAP": "",
        }
      }
    });

    vm.getCountrySettings = function () {
      var country = _.find(vm.validCountriesWithFullName, {id: vm.location.address.country});
      return country ? country.settings : {};
    };

    vm.hasError = function (input) {
      if (!input) return;
      return input.$invalid && (input.$dirty || !!input.$viewValue || vm.createEditLocForm.$submitted);
    };

    vm.searchCriteriaModifiers = [
      {
        id: 'Includes',
        name: 'Must Include'
      },
      {
        id: 'DoesntInclude',
        name: 'Must Not Include'
      }
    ];

    vm.websiteRegex = new RegExp(/^(?!(.*utm_source=.*))/i)

    vm.addAdditionalWebsite = function () {
      var defaultCriteria = {modifier: 'Includes', searchCriteriaText: ''};
      vm.location.brandMonitoring.socialSearchCriteria.push(defaultCriteria);
    };

    vm.removeAlternatePhoneNumber = function (phoneNumber) {
      vm.createEditLocForm.$setDirty();
      vm.location.alternatePhoneNumbers = _.without(vm.location.alternatePhoneNumbers, phoneNumber);
    };

    vm.newAlternatePhoneNumber = function () {
      vm.location.alternatePhoneNumbers.push({phoneNumber: ''});
    };

    vm.removeAlternateEmail = function (email) {
      vm.createEditLocForm.$setDirty();
      vm.location.alternateEmails = _.without(vm.location.alternateEmails, email);
    };

    vm.newAlternateEmail = function () {
      // Inform user to set up location specific alerts in the my alerts section.
      vm.openMyAlertsModal()
      vm.location.alternateEmails.push({email: ''});
    };



    vm.openMyAlertsModal = function () {
      let modalInstance = $uibModal.open({
        template: `
          <div class="modal-header">
          <h4 class="modal-title">Email Alert Updates</h4>
        <button type="button" class="close" data-dismiss="modal">
          <span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
      </div>
                        <div class="modal-body" style="margin-top:0">
                          <p>
          <span style="font-weight:bold;">My Alerts</span> now supports location-specific email alerts.
          Simply add a new user and they will be included in email alerts for their location(s).
          Explore <span style="font-weight:bold;">My Alerts</span> now by clicking <a style="font-weight:bold;" href="" ng-click="myAlertEmailRedirect()">here</a>!
        </p>
                        </div>
                        <div class="modal-footer">
        <button type="button" class="btn btn-secondary" ng-click="close()" >
          OK
        </button>
      </div>`,
        controller: ($scope) => {
          $scope.myAlertEmailRedirect = function () {
            $scope.$close()
            $state.go('emailAlerts.manage')
          }
          $scope.close = function () {
            $scope.$close()
          }
        },
        size: 'sm'
      });

      modalInstance.result.then(function(updated) {
      })
    }


    vm.removeAlternateWebsite = function (website) {
      vm.createEditLocForm.$setDirty();
      vm.location.alternateWebsites = _.without(vm.location.alternateWebsites, website);
    };

    vm.newAlternateWebsite = function () {
      vm.location.alternateWebsites.push({website: ''});
    };

    vm.removeRankingKeyword = function (rankingKeyword) {
      vm.createEditLocForm.$setDirty();
      vm.location.rankingKeywords = _.without(vm.location.rankingKeywords, rankingKeyword);
    };

    vm.newRankingKeyword = function () {
      var defaultRankingKeyword = {keyword: '', localArea: ''};
      vm.location.rankingKeywords.push(defaultRankingKeyword);
    };

    vm.maxRowsReached = function (array, type) {
      return vm.maxRepeaterItems[type] == array.length;
    }

    vm.cleanPhoneNumber = function (phoneNumber) {
      return phoneNumber.replace(/\D/g, '');
    }


    vm.setImage = function(targetField) {
      return (img) => vm[targetField] = img.url
    }

    vm.imageSelected = function(image) {
      vm.location.listingManagementSpecs = vm.location.listingManagementSpecs || {}
      vm.location.listingManagementSpecs.imageUrls = vm.location.listingManagementSpecs.imageUrls || []
      if (image && vm.location.listingManagementSpecs.imageUrls.indexOf(image.url) === -1) {
        vm.location.listingManagementSpecs.imageUrls.push(image.url)
        vm.createEditLocForm.$setDirty()
      }
    }

    vm.yelpImageSelected = function(image) {
      vm.location.listingManagementSpecs = vm.location.listingManagementSpecs || {}
      vm.location.listingManagementSpecs.yelpImages = vm.location.listingManagementSpecs.yelpImages || []
      // if (image && vm.location.listingManagementSpecs.yelpImages.findIndex(i => image.url === i.url) === -1) {
      vm.location.listingManagementSpecs.yelpImages.push({
        url: image.url,
        caption: ""
      })
      vm.createEditLocForm.$setDirty()
      // }
    }

    const initGoogleListingManagementPhotos = () => {
      if (vm.location.googleListingManagementSpecs && vm.location.googleListingManagementSpecs.photos) {
        vm.googleCoverPhoto = vm.location.googleListingManagementSpecs.photos.find(x => x.locationAssociationCategory === "COVER");
        vm.googleProfilePhoto = vm.location.googleListingManagementSpecs.photos.find(x => x.locationAssociationCategory === "PROFILE");
      }
    }

    vm.googleImageSelected = function(image) {
      vm.location.googleListingManagementSpecs = vm.location.googleListingManagementSpecs || {}
      vm.location.googleListingManagementSpecs.photos = vm.location.googleListingManagementSpecs.photos || []
      // if (image && vm.location.listingManagementSpecs.googleImages.findIndex(i => image.url === i.url) === -1) {
      vm.location.googleListingManagementSpecs.photos.push({
        sourceUrl: image.url,
        locationAssociationCategory: "ADDITIONAL",
      })
      vm.createEditLocForm.$setDirty()
      // }
    }

    vm.removeImage = function(index) {
      vm.location.listingManagementSpecs.imageUrls.splice(index, 1)
      vm.createEditLocForm.$setDirty()
    }

    vm.removeYelpImage = function(index) {
      vm.location.listingManagementSpecs.yelpImages.splice(index, 1)
      vm.createEditLocForm.$setDirty()
    }

    vm.removeGoogleCoverImage = () => {
      vm.location.googleListingManagementSpecs.photos = vm.location.googleListingManagementSpecs.photos.filter(x => x.locationAssociationCategory !== "COVER")
      vm.createEditLocForm.$setDirty()
      initGoogleListingManagementPhotos()
    }

    vm.setGoogleProfilePhoto = function(image) {
      vm.location.googleListingManagementSpecs = vm.location.googleListingManagementSpecs || {}
      vm.location.googleListingManagementSpecs.photos = vm.location.googleListingManagementSpecs.photos || []
      // if (image && vm.location.listingManagementSpecs.googleImages.findIndex(i => image.url === i.url) === -1) {
      vm.location.googleListingManagementSpecs.photos.push({
        sourceUrl: image.url,
        locationAssociationCategory: "PROFILE",
      })
      vm.createEditLocForm.$setDirty()
      // }
      initGoogleListingManagementPhotos()
    }

    vm.setGoogleCoverPhoto = function(image) {
      vm.location.googleListingManagementSpecs = vm.location.googleListingManagementSpecs || {}
      vm.location.googleListingManagementSpecs.photos = vm.location.googleListingManagementSpecs.photos || []
      // if (image && vm.location.listingManagementSpecs.googleImages.findIndex(i => image.url === i.url) === -1) {
      vm.location.googleListingManagementSpecs.photos.push({
        sourceUrl: image.url,
        locationAssociationCategory: "COVER",
      })
      vm.createEditLocForm.$setDirty()
      // }
      initGoogleListingManagementPhotos()
    }

    vm.removeGoogleProfileImage = () => {
      vm.location.googleListingManagementSpecs.photos = vm.location.googleListingManagementSpecs.photos.filter(x => x.locationAssociationCategory !== "PROFILE")
      vm.createEditLocForm.$setDirty()
      initGoogleListingManagementPhotos()
    }

    vm.removeGoogleImage = function(index) {
      vm.location.googleListingManagementSpecs.photos.splice(index, 1)
      vm.createEditLocForm.$setDirty()
      initGoogleListingManagementPhotos()
    }

    vm.photoRows = [];
    const setPhotoRows = () => {
      vm.photoRows = [{
        path: ['logoUrl'],
        title: 'Logo',
        min: { width: 250, height: 250 },
        max: { width: 5000, height: 5000 }
      }];
      if (!vm.isGoogleListingManagement) {
        vm.photoRows.push({
          path: ['providerImages', 'GOOGLEMAP'],
          title: 'Google Cover Photo',
          tooltip: 'Your photos will look best on Google if they are at least 720px tall, 720px wide',
          min: { width: 480, height: 270 },
          max: { width: 1920, height: 1080 }
        })
      }
      //removed twitter at Xander's request
    }

    vm.setFacebookCoverPhotoUrl = imageObj => {
      vm.location.facebookListingManagementSpecs.coverPhotoUrl = imageObj.url;
      vm.createEditLocForm.$setDirty();
    }

    vm.getListingManagementSpecsAttribute = (path) => {
      return path.reduce((s, f) => s[f], vm.location.listingManagementSpecs)
    }

    vm.setListingManagementSpecsAttribute = path => value => {
      vm.createEditLocForm.$setDirty()
      let pCopy = path.slice()
      let obj = vm.location.listingManagementSpecs
      while (pCopy.length > 1) {
        obj = obj[pCopy.shift()]
      }
      obj[pCopy[0]] = value
    }

    vm.setListingPhoto = path => imageObj => {
      vm.setListingManagementSpecsAttribute(path)(imageObj.url)
    }

    var handleLocationUpdateResponse = function (response) {
      if (response.status == 200) {
        vm.processSuccessfulAddLocation(response);
        vm.state = states.Success;
      } else {
        vm.state = states.UserEditing;
        vm.errorMsg = 'Unknown Error Occurred';
        if (response.error == 'duplicate_location') {
          vm.errorMsg = 'Location exists with same business name and address!'
        }
      }
    };

    var handleErrorResponse = function (response) {
      vm.state = states.UserEditing;
      if (response.data.error.message == 'existing_reseller_location_id') {
        vm.errorMsg = 'The client location id you are trying to use exist already.'
        return
      } else if(response.data.error.message == "Entered coordinates are too distant from calculated coordinates") {
        vm.errorMsg = response.data.error.message
        return
      } else if(response.data.error.message.includes("has fixed listings")) {
        vm.errorMsg = response.data.error.message
        return
      }
      vm.errorMsg = 'Internal error; please contact support.';
    };

    //Uses status to determine if the specific day has not been populated. Since blocks may be empty on closed
    //that's not reliable. By default the code creates an empty blocks array for closed hours. Hence the previous
    //bug with validation ignoring empty blocks.
    vm.areAnyRegularBusinessHoursEmpty = () => {
      let hours = vm.location.listingManagementSpecs.hours;
      let missingData = Object.keys(hours).filter(day => typeof hours[day].status == "undefined")
      return missingData.length > 0
    };

    vm.submit = function Submit() {

      vm.formSubmitted = true;


      vm.validateRegularHourBlocks()

      const validForm = vm.createEditLocForm.$valid;
      if (!validForm ) {
        return;
      }

      delete vm.errorMsg;
      vm.state = states.PendingConfirmation;

      //Clean location
      var countrySettings = vm.getCountrySettings();
      if (!countrySettings.includeState) {
        vm.location.state = null;
      }

      //convert to AL hours - from 12:00 PM to 1200 (note 12:00 24:00 are not supported by AL)
      //only if applicable for location management
      vm.toALtimeformat();

      //Filter out additional data with empty values.
      vm.location.alternateEmails = _.filter(vm.location.alternateEmails, function (email) {
        return email.email.length > 0;
      });
      vm.location.rankingKeywords = _.filter(vm.location.rankingKeywords, function (rankingKeyword) {
        return rankingKeyword.keyword.length > 0;
      });
      vm.location.brandMonitoring.socialMonitoring = _.filter(vm.location.brandMonitoring.socialMonitoring, function (bm) {
        return bm.name.length > 0;
      });
      _.each(vm.location.brandMonitoring.socialMonitoring, function (item) {
        item.searchCriteria = _.filter(item.searchCriteria, function (sc) {
          return sc.searchCriteriaText.length > 0;
        })
      });

      vm.location.brandMonitoring.listingMonitoring = _.filter(vm.location.brandMonitoring.listingMonitoring, function (lm) {
        return lm.name !== '';
      });

      vm.location.primaryPhone = vm.cleanPhoneNumber(vm.location.primaryPhone);
      if (vm.location.faxNumber) {
        vm.location.faxNumber = vm.cleanPhoneNumber(vm.location.faxNumber);
      }

      vm.location.alternatePhoneNumbers = _.filter(vm.location.alternatePhoneNumbers, function (pn) {
        return pn.phoneNumber.length > 0;
      });

      _.each(vm.location.alternatePhoneNumbers, function (item) {
        item.phoneNumber = vm.cleanPhoneNumber(item.phoneNumber);
      });

      vm.location.alternateWebsites = _.filter(vm.location.alternateWebsites, function (ws) {
        return ws.website.length > 0;
      });

      const cleanAddressField = (field) => {
        return field !== "" && field || null
      }

      vm.location.address = {
        street : cleanAddressField(vm.postalAddress.streetAddress),
        city: cleanAddressField(vm.postalAddress.addressLocality),
        state: cleanAddressField(vm.postalAddress.addressRegion),
        country: cleanAddressField(vm.postalAddress.addressCountry),
        postalCode: cleanAddressField(vm.postalAddress.postalCode),
        suite: cleanAddressField(vm.postalAddress.suite),
        isServiceAreaLocation: vm.postalAddress.isServiceAreaLocation
      }


      if (vm.location.listingManagementSpecs) {
        vm.location.listingManagementSpecs.additionalCategories = _.filter(vm.location.listingManagementSpecs.additionalCategories, x => x !== null);
        vm.location.listingManagementSpecs.paymentTypes = _.filter(vm.paymentTypes, p => p.selected).map(p => p.display).join(",");

        if (!!vm.location.listingManagementSpecs.temporarilyClosedUntil) {
          vm.location.listingManagementSpecs.temporarilyClosedUntil = moment(vm.location.listingManagementSpecs.temporarilyClosedUntil).format("YYYY-MM-DD")
        }

        if(!!vm.location.listingManagementSpecs.bingCategories) {
          vm.location.listingManagementSpecs.bingCategories = Array.from(vm.location.listingManagementSpecs.bingCategories)
        }

        if(!!vm.location.listingManagementSpecs.appleCategories) {
          vm.location.listingManagementSpecs.appleCategories = Array.from(vm.location.listingManagementSpecs.appleCategories)
        }

        if (Array.isArray(vm.location.listingManagementSpecs.specialHoursPeriods)) {
          vm.location.listingManagementSpecs.specialHoursPeriods.forEach(specialHourPeriod => {
            // Set start date to end date because we removed the end date field
            // We only allow for single dates now
            // TODO - remove end date on back end and clean this up
            specialHourPeriod.specialEndDate = specialHourPeriod.specialStartDate
          })
        }
      }

      if (vm.mode == 'create') {
        if (vm.locationType == 'Customer') {
          locationsManagerService.addLocation(vm.location).then(handleLocationUpdateResponse).catch(handleErrorResponse);
        } else if (vm.locationType == 'Competitor') {
          locationsManagerService.addCompetitorLocation(locationId, vm.location).then(handleLocationUpdateResponse).catch(handleErrorResponse);
        }
      } else if (vm.mode == 'edit') {
        if (vm.locationType == 'Customer') {
          locationsManagerService.updateLocation(vm.location).then(handleLocationUpdateResponse).catch(handleErrorResponse);
        } else if (vm.locationType == 'Competitor') {
          locationsManagerService.updateCompetitorLocation(locationId, $stateParams.competitorId, vm.location).then(handleLocationUpdateResponse).catch(handleErrorResponse);
        }
      }

    };

    vm.cancel = function () {
      if(vm.isModalView) {
        $uibModalInstance.dismiss('cancel');
        return
      }
      if (isCustomer()) {
        $location.path('admin/v2/locations');
      }
      else {
        $location.path('admin/v2/locations/' + vm.locationId + '/competitors');
      }
    }

    vm.processSuccessfulAddLocation = function (response) {
      var newLocation = response.data;
      vm.state = 'Success';
      var path = vm.locationType === 'Customer' ? '/admin/v2/locations' : '/admin/v2/locations/' + vm.locationId + '/competitors';
      var updateInfo = {
        status: 'Active',
        type: vm.locationType === 'Customer' ? 'location' : 'competitor',
        title: vm.locationType === 'Customer' ? 'Location' : 'Competitor',
        destinationRole: 'manage',
        notificationType: 'detail',
        actions: [{action: vm.mode}],
        name: newLocation.busName,
        searchParam: newLocation.busName,
        id: newLocation.id
      }
      updateService.registerSuccessfulUpdate(updateInfo);
      if(vm.isModalView) {
        $uibModalInstance.close(newLocation);
      }  else {
        $location.path(path);
      }
    }

    // OK! so we need to handle the case where we have a category selected already, but it's not eligible for listing management.
    // going to need to query for that category when the datas load
    // and maybe just clear it / set a warning flag
    // could always make a suggestion endpoint, given a specific keyword?
  }
})();
